// src/pages/ContactPage.jsx
import React from "react";
import { FooterSection } from "../components/Footer.jsx";
import { ContactForm } from "../components/ContactForm.jsx";

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-zinc-900 text-gray-100">
      {/* Header */}
      <header className="bg-[#1a1a1a] border-b border-[#FF4D00]/10">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <h1 className="text-3xl font-bold bg-gradient-to-r from-[#FF4D00] to-[#FF8C00] bg-clip-text text-transparent">
            Contact Us
          </h1>
        </div>
      </header>

      {/* Content */}
      <main className="py-12">
        <div className="max-w-4xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8 items-start">
            {/* Form */}
            <div className="bg-white/5 p-8 rounded-2xl backdrop-blur-sm border border-[#FF4D00]/10">
              <ContactForm />
            </div>

            {/* Company Information */}
            <div className="space-y-6">
              <div className="bg-white/5 p-6 rounded-xl backdrop-blur-sm border border-[#FF4D00]/10">
                <h2 className="text-xl font-semibold mb-4 text-[#FF4D00]">
                  Our Office
                </h2>
                <div className="space-y-3 text-gray-300">
                  <p>Firmenname</p>
                  <p>Adresse</p>
                  <p>PLZ Stadt</p>
                  <p>Germany</p>
                </div>
              </div>

              <div className="bg-white/5 p-6 rounded-xl backdrop-blur-sm border border-[#FF4D00]/10">
                <h2 className="text-xl font-semibold mb-4 text-[#FF4D00]">
                  Contact Information
                </h2>
                <div className="space-y-3">
                  <p className="text-gray-300">Email us at:</p>
                  <a
                    href="mailto:contact@helga-app.com"
                    className="text-[#FF4D00] hover:text-[#FF6B00] transition block"
                  >
                    contact@helga-app.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <>
        <FooterSection />
      </>
    </div>
  );
};

export default ContactPage;
